
import { css } from 'lit';
export default css`
:host{
  --pc-container-sm-width:926px;
  --pc-container-md-width:1024px;
  --pc-container-lg-width:1152px;
  --pc-container-xl-width:1280px;
  --pc-container-2xl-width:1440px;
}
dialog{
  max-width:var(--pc-container-2xl-width);
  border:2px solid var(--purple-indigo);
  padding:1.5rem;
}
dialog::backdrop{
    background:black;
    opacity:0.6;
  }
::slotted([slot='dialog-content']){
  margin-bottom:1rem;
}
.cto-container{
  display:flex;
  gap:2rem;
  justify-content:center;
}
`;